
import { StrategyWithDetails } from "@/types/strategy-types";
import { AccountPerformanceData } from "./marketplace/types/strategy-card-types";
import StrategyDetailDialog from "./strategy-detail/StrategyDetailDialog";

interface StrategyDetailProps {
  isOpen: boolean;
  onClose: () => void;
  strategy: StrategyWithDetails | undefined;
  performanceData?: AccountPerformanceData;
}

const StrategyDetail = ({ isOpen, onClose, strategy, performanceData }: StrategyDetailProps) => {
  return (
    <StrategyDetailDialog
      isOpen={isOpen}
      onClose={onClose}
      strategy={strategy}
      performanceData={performanceData}
    />
  );
};

export default StrategyDetail;
